import { Theme } from "@mui/material"
import { makeStyles } from "@mui/styles"

const useButtonStyles = makeStyles((theme: Theme) => ({
    containedPrimary: {
        borderRadius: 100,
        padding: theme.spacing(1.25, 4),
        background: theme.palette.custom.gradiantPrimary,
        boxShadow: 'none',

        '&.Mui-disabled': {
            borderColor: theme.palette.grey[400]
        },
        '&:hover' : {
            boxShadow: 'none',
        }
    },
    outlinedPrimary: {
        borderRadius: 100,
        padding: theme.spacing(1.25, 4),
        boxShadow: 'none',

        '&:hover' : {

            fontWeight: 600
        }
    },
    textPrimary: {
        borderRadius: 100,
        padding: theme.spacing(1.25, 4),
        color: theme.palette.text.primary,
        boxShadow: 'none',
    }
}))

export default useButtonStyles
